import api from '@/services/api';
import type {
  TaskExecution,
  TaskExecutionPage,
  WorkerPool,
  WorkerPoolListReply,
} from '@/types/taskPlatform';

export const TASK_ID_PATTERN = /^task_[a-f0-9]{64}$/;
export const WORKER_POOL_ID_PATTERN = /^[a-f0-9]{64}$/;

function encode(value: string) {
  return encodeURIComponent(value.trim());
}

export const taskPlatformApi = {
  listWorkerPools: () =>
    api.get<never, WorkerPoolListReply>('/api/v1/task-platform/worker-pools'),

  getWorkerPool: (workerPoolId: string) =>
    api.get<never, WorkerPool>(
      `/api/v1/task-platform/worker-pools/${encode(workerPoolId)}`,
    ),

  listTasks: (workerPoolId: string, cursor = '', limit = 20) =>
    api.get<never, TaskExecutionPage>(
      `/api/v1/task-platform/worker-pools/${encode(workerPoolId)}/tasks`,
      { params: { cursor: cursor || undefined, limit } },
    ),

  getTask: (taskId: string) =>
    api.get<never, TaskExecution>(
      `/api/v1/task-platform/tasks/${encode(taskId)}`,
    ),
};

interface ApiErrorLike {
  message?: string;
  response?: {
    data?: {
      error?: string | { message?: string };
      message?: string;
    };
  };
}

export function taskPlatformErrorMessage(error: unknown, fallback: string) {
  if (!error || typeof error !== 'object') {
    return fallback;
  }
  const value = error as ApiErrorLike;
  const responseError = value.response?.data?.error;
  if (typeof responseError === 'string' && responseError.trim()) {
    return responseError;
  }
  if (
    responseError &&
    typeof responseError === 'object' &&
    responseError.message?.trim()
  ) {
    return responseError.message;
  }
  return value.response?.data?.message || value.message || fallback;
}
